import React, { Fragment, useState } from 'react';
import FieldInputProps from './fieldInput';

export const FieldInput = ({
  name,
  label,
  value,
  onClick,
  onChange,
  onBlur,
  minLength = 0,
  maxLength = 50,
  type = 'text',
  placeholder = '',
  noshow = false,
  disabled = false,
  readonly = false,
  required = false,
  autoComplete = 'off',
  lpIgnore = 'true',
  inputClass = "",
}: FieldInputProps) => {
  const [changed, setChanged] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChanged(true);

    if (onChange) {
      onChange(e);
    }
  };

  return (
    <Fragment>
      <label htmlFor={name} className='block mb-1'>
        {label}
        {(minLength > 0 || required) && <span className='pl-1 text-red-500'>*</span>}
      </label>
      <input
        type={type}
        disabled={noshow ?? disabled}
        name={name}
        id={name}
        value={value}
        minLength={minLength}
        maxLength={maxLength}
        onClick={onClick}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder}
        autoComplete={autoComplete}
        data-lpignore={lpIgnore}
        className={inputClass}
        readOnly={readonly}
      />
      {changed && ((typeof (value) === 'string' && value.length === 0) || typeof (value) === 'number') && minLength > 0 && (
        <p className='mt-2 italic text-red-500'>{label} is required.</p>
      )}
    </Fragment>
  );
};
